import { Button } from '@heroui/react';
import { Heart } from 'iconsax-react';

export const ProductFavorite = ({
  isSelected = false,
  onPress,
  size = 'sm',
  isAbsolute = true,
}: {
  isSelected?: boolean;
  onPress?: () => void;
  size?: 'sm' | 'lg';
  isAbsolute?: boolean;
}) => {
  if (isSelected) {
    return (
      <Button
        radius="full"
        isIconOnly
        variant="light"
        className={isAbsolute ? 'bg-white absolute top-3 right-3' : ''}
        startContent={
          <Heart
            className="select-none border-none outline-none"
            color="#F53639"
            size={size === 'lg' ? '24' : '20'}
            variant="Bold"
          />
        }
        onPress={onPress}
      />
    );
  }
  return (
    <Button
      radius="full"
      isIconOnly
      variant="light"
      className={isAbsolute ? 'bg-white absolute top-3 right-3' : ''}
      startContent={
        <Heart
          className="select-none border-none outline-none"
          color="#222222"
          size={size === 'lg' ? '24' : '20'}
          variant="Outline"
        />
      }
      onPress={onPress}
    />
  );
};
